import { ComponentPropsWithRef, forwardRef, ReactNode } from "react";
import Text from "./Text";
import Padding from "./Padding";
import Flex from "./Flex";
import Card from "./Card";
import useDevice from "../hooks/useDevice";
import Spacer from "./Spacer";
import Loading from "./Loading";
import useDelayedLoading from "../hooks/useDelayedLoading";

type ManagementProps = ComponentPropsWithRef<"div"> & {
    title: string;
    actions?: ReactNode;
    searchArea?: ReactNode;
    children?: ReactNode;
};


function ManagementPage({
    title,
    actions,
    searchArea,
    children
}: ManagementProps) {
    const device = useDevice();
    const isMobile = device !== 'mobile'
    const isLoadingComponent = useDelayedLoading(500);

    return (
        <>
            <Loading isLoading={isLoadingComponent} minDuration={300} message="Loading..."/>
            <div className="contents" style={{backgroundColor: "#F9FAFC", userSelect: "none"}}>
                <Flex alignItems="center" justifyContent="space-between">
                    <Text size={'xl'} weight={'bold'}>{title}</Text>
                    <Flex gap={5}>
                        {actions}
                    </Flex>
                </Flex>

                <Spacer direction="vertical" size={10} />

                <Card fullWidth>
                    <Padding>
                        <Flex gap={isMobile ? 12 : 30} flexDirection={isMobile ? 'column' : 'row'}>
                            <Flex alignItems='center'>
                                {searchArea}
                            </Flex>
                        </Flex>
                    </Padding>
                </Card>
                
                <Spacer direction="vertical" size={20} />
                
                {children}
            </div>
        </>
    )
}

export default ManagementPage;